import { Fancybox } from '@fancyapps/ui';
import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  // Bind Fancybox on all person gallery links (grouped per post)
  Fancybox.bind('[data-fancybox^="person-gallery-"]', {
    animated: true,
    groupAll: false,
  });

  // Init Swiper thumbnail strips
  document.querySelectorAll('.person-single__thumbs').forEach((el) => {
    const wrapper = el.closest('.person-single__thumbs-wrapper');

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      navigation: {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      },
    });
  });
});
